import { GeschaeftspartnerListPage } from "@/pages/kontakte/GeschaeftspartnerListPage";

export function LieferantenIndexPage() {
  return (
    <GeschaeftspartnerListPage
      typ="lieferant"
      title="Lieferanten"
      detailBasePath="/kontakte/lieferanten"
    />
  );
}
